export const FACEBOOK_URL = 'https://www.facebook.com/DaveWaveStudio';
export const INSTAGRAM_URL = 'https://www.instagram.com/davewavestudio/';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCGP5Wi8UhLK79ughi1FjWzA';
export const GOOGLE_REVIEWS_PAGE = 'https://www.google.com/search?q=dave+wave+studio&rlz=1C5CHFA_enPL1015PL1015&oq=dave+wave&aqs=chrome.0.35i39i355j46i39i175i199j69i57j0i512j46i512j69i60l3.1870j0j7&sourceid=chrome&ie=UTF-8#';
